import { render, staticRenderFns } from "./CircleLogoOrPlaceholder.vue?vue&type=template&id=1ae6c5bb&scoped=true&lang=pug"
import script from "./CircleLogoOrPlaceholder.vue?vue&type=script&lang=js"
export * from "./CircleLogoOrPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./CircleLogoOrPlaceholder.vue?vue&type=style&index=0&id=1ae6c5bb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae6c5bb",
  null
  
)

export default component.exports